module.exports = __webpack_public_path__ + "static/mr-press-30-5f0972089c7df9cd38aa1d37b7ef70f2.jpg";